import { Injectable } from '@angular/core';
import { inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { LocalStorageService } from '../services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private localStorageService = inject(LocalStorageService);
  private router = inject(Router);

  canActivate(): boolean | UrlTree {
    const token = this.localStorageService.getItem('token');

    if (token) {
      return true;
    }

    return this.router.parseUrl('/auth/login');
  }
}
